'use client';

import hexToRgba from 'hex-to-rgba';
import { ReactNode } from 'react';
import { Modal as RNModal, StyleProp, TouchableOpacity, ViewStyle } from 'react-native';
import { SystemBars } from 'react-native-edge-to-edge';
import { gestureHandlerRootHOC } from 'react-native-gesture-handler';
import { KeyboardAvoidingView } from 'react-native-keyboard-controller';

import { useTheme } from '../styles';

type Props = {
  onRequestClose: () => void;
  visible: boolean;
  children: ReactNode;
  style: StyleProp<ViewStyle>;
  testID?: string;
};

const ModalInner = gestureHandlerRootHOC((props: Props) => {
  const { theme } = useTheme();
  return (
    <TouchableOpacity
      testID={props.testID}
      accessible={false}
      activeOpacity={1}
      style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: hexToRgba(theme.color.gray100, '0.5'),
      }}
      onPress={props.onRequestClose}
    >
      {props.visible ? <SystemBars style="light" /> : null}
      <TouchableOpacity accessible={false} activeOpacity={1} style={props.style}>
        {props.children}
      </TouchableOpacity>
    </TouchableOpacity>
  );
});

export function ModalContainer(props: Props) {
  return (
    <RNModal visible={props.visible} transparent onRequestClose={() => {}}>
      <KeyboardAvoidingView
        style={{ flex: 1 }}
        behavior="padding"
        onAccessibilityEscape={props.onRequestClose}
      >
        <ModalInner {...props} />
      </KeyboardAvoidingView>
    </RNModal>
  );
}
